export default "__VITE_ASSET__CM08TEdF__"